// extracted by mini-css-extract-plugin
export default {"section":"style_section__4I4xN","sectionHeading":"style_sectionHeading__F0JFZ","sectionIcon":"style_sectionIcon__MawKW","wrapp":"style_wrapp__6fo3b"};